import { UploadExcelThemeSizeConfig } from './types';

const large: UploadExcelThemeSizeConfig = {
  uploadExcel: {},
};

export default large;
